<template>
  <!--
      作者：zhuchangtao
      时间：2021-08-17
      描述：插件中心-线上视频课程
    -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="课程管理" name="second"><Course v-if="activeName == 'second'"></Course></el-tab-pane>
      <el-tab-pane label="视频管理" name="first"><Chapter v-if="activeName == 'first'"></Chapter></el-tab-pane>
      <el-tab-pane label="购买记录" name="third"><Record v-if="activeName == 'third'"></Record></el-tab-pane>
     <!-- <el-tab-pane label="基础设置" name="fourth"><getSetting v-if="activeName == 'fourth'"></getSetting></el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import Chapter from './chapter/index';
import Course from './course/index';
import Record from './record/index';
import getSetting from './setting/getSetting.vue';
export default {
  components: {
    /*章节管理*/
    Chapter,
    /*课程管理*/
    Course,
    /*基础设置*/
    getSetting,
    /*购买记录*/
    Record
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      activeName: 'second'
    };
  },
  created() {
    let active_name = localStorage.getItem('activeName')
    if(active_name){
      this.activeName = active_name
      localStorage.clear()
    }
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/course/index.vue